// extracted by mini-css-extract-plugin
export default {"imgContainer":"incompleteComponents_imgContainer__21Vya"};